/**
 * Hallazgo #2 (smoke 2026-09-08) — leyenda de privacidad OBLIGATORIA en la página
 * pública de autofactura (recibe datos fiscales del cliente final, igual que la
 * tienda y las reservas). Helper PURO para poder testearla con vitest sin jsdom:
 * la página la renderiza tal cual + enlace a /aviso/{slug} cuando existe.
 */
export interface AvisoLegend {
  text: string;
  /** null = el tenant no ha publicado su aviso (la leyenda sale sin enlace). */
  avisoUrl: string | null;
  linkLabel: string;
}

export function avisoLegend(tenantName: string, avisoUrl: string | null): AvisoLegend {
  const negocio = (tenantName ?? '').trim() || 'el negocio';
  return {
    text:
      `Tus datos fiscales se usan únicamente para emitir tu factura (CFDI) y se tratan ` +
      `conforme al aviso de privacidad de ${negocio}.`,
    avisoUrl,
    linkLabel: 'Consulta el aviso de privacidad',
  };
}
